module.exports = ".ssf-power {\n  position: relative; }\n\n.ssf-power__outer {\n  position: absolute;\n  left: -10px;\n  top: -10px;\n  overflow: hidden;\n  width: 44px;\n  height: 44px;\n  transform: scale(0.7);\n  fill: currentColor; }\n\n.ssf-power__inner {\n  width: 1.6rem;\n  height: 1.6rem;\n  font-size: 1.6rem;\n  line-height: 1.6rem;\n  fill: currentColor; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.scss
// module id = 790
// module chunks = 3